import React, { useState } from "react";
import GUI_Header from "./GUI_Header";
import GUI_InputTextSingle from "./GUI_InputTextSingle";
import GUI_Credit from "./GUI_Credit";
import T from "../TheTool";

function GUIset_nInput(props) {
	var title1 = T.getValue(props.title, "");
	var desc1 = T.getValue(props.desc, "");
	var n = T.getValue(props.n, 3);
	var style = T.getValue(props.style, 0);
	//STANDARD
	var labelSize0 = 22;
	var sizeTxt0 = 22;
	var width1 = 120;
	var width2 = "80%";
	var but_marginLeft = "16%";
	var but_marginRight = 0;
	if (style == 1) {
		labelSize0 = 26;
		sizeTxt0 = 28;
		width1 = 120;
		width2 = "80%";
		but_marginLeft = "20%";
		but_marginRight = "0%";
	}
	labelSize0 = T.getValue(props.sizeLabel, labelSize0);
	sizeTxt0 = T.getValue(props.sizeTxt, sizeTxt0);
	width1 = T.getValue(props.width1, width1);
	width2 = T.getValue(props.width2, width2);
	but_marginLeft = T.getValue(props.but_marginLeft, but_marginLeft);
	but_marginRight = T.getValue(props.but_marginRight, but_marginRight);
	//
	var txtButton = T.getValue(props.txtButton, "Click");
	//------------------------------------------------------------
	var headerStyle = T.getValue(props.headerStyle, 1);
	//1 standard, 0 no header, 2 with bullet
	var headerPreBullet = T.getValue(props.headerPreBullet, null);
	var headerBullet = T.getValue(props.headerBullet, []);
	var headerBulletItems = null;
	if (headerBullet.length > 0) {
		headerBulletItems = headerBullet.map((b, i) => (
			<li key={"bullet" + i}>{b}</li>
		));
	}
	//------------------------------------------------------------
	var inputs = props.inputFields;
	var initialInput = Array(n);
	for (var i = 0; i < inputs.length; i++) {
		initialInput[i] = T.getValue(inputs[i].text, "");
	}
	const [inputArr, setInputArr] = useState(initialInput); //Array that store all input
	//------------------------------------------------------------
	function loadInputFields() {
		return inputs.map((input, index) => {
			// function TextChange(v) { //FAIL to update state
			// 	// console.log("handle" + index + "_" + v);
			// 	props.handleTextChange(index, v);
			// }
			//https://stackoverflow.com/questions/26253351/correct-modification-of-state-arrays-in-react-js
			//https://beta.reactjs.org/learn/updating-arrays-in-state
			//https://stackoverflow.com/questions/29537299/how-can-i-update-state-item1-in-state-using-setstate			
			function TextChange_v2(v) {
				let newArr = [...inputArr];
				newArr[index] = v;
				setInputArr(newArr);
			}
			// var this_text = T.getValue(input.text, "");
			var this_text = inputArr[index];
			var this_label = T.getValue(input.label, "Input" + (index + 1));
			var this_numberOnly = T.getValue(input.numberOnly, false);
			var this_labelsize = T.getValue(input.labelsize, labelSize0);
			var this_fontSize = T.getValue(input.fontSize, sizeTxt0);
			var this_width1 = T.getValue(input.width1, width1);
			var this_width2 = T.getValue(input.width2, width2);
			return (
				<div key={index}>
					<GUI_InputTextSingle
						// text1={input.text}//not work
						// text1Change={this_TextChange}//not work
						// text1Change={input.textChange}//not work
						// text1Change={TextChange}
						text1={this_text}
						text1Change={TextChange_v2}
						label={this_label}
						labelsize={this_labelsize}
						numberOnly={this_numberOnly}
						fontSize={this_fontSize}
						width1={this_width1}
						width2={this_width2}
					/>
				</div>
			);
		});
	}

	function handleButtonClick() {
		// console.log("handle" + inputArr.toString());
		props.handleButtonClick(inputArr);
	}

	function head() {
		return headerStyle == 0 ? (
			<div></div>
		) : (
			<GUI_Header title={title1} desc={desc1} desc_v2={props.desc_v2}/>
		);
	}

	function header_prebullet() {
		return headerPreBullet != null ? (
			<div style={{ alignItems: "right", fontSize: 19, marginTop: 5 }}>
				{headerPreBullet}
			</div>
		) : (
			<div></div>
		);
	}

	function head_bullet() {
		return headerBulletItems != null ? (
			<div
				style={{
					alignItems: "right",
					paddingLeft: 50,
					marginTop: 5,
					fontSize: 18,
				}}
			>
				{headerBulletItems}
			</div>
		) : (
			<div></div>
		);
	}

	function space() {
		return headerStyle == 0 ? (
			<div></div>
		) : (
			<div style={{ marginTop: "3em" }}> </div>
		);
	}

	function buttons() {
		return (
			<div
				style={{
					display: "flex",
					marginLeft: but_marginLeft,
					marginRight: but_marginRight,
				}}
			>
				<button
					// onClick={() => props.buttonClick1()}
					onClick={() => handleButtonClick()}
					className="btn btn__primary btn__lg"
					style={{ flex: 1, height: 50 }}
				>
					{txtButton}
				</button>
			</div>
		);
	}

	return (
		<div className="todoapp stack-large">
			{head()}
			{header_prebullet()}
			{head_bullet()}
			{space()}
			{loadInputFields()}
			<div style={{ marginTop: "3em" }}> </div>
			{buttons()}
			<div style={{ marginTop: "3em" }}> </div>
			{props.partResult}
			<GUI_Credit />
		</div>
	);
}
export default GUIset_nInput;
